import { render, staticRenderFns } from "./TabelaResultadosProjetoGovernador.vue?vue&type=template&id=71dd70c4&scoped=true"
import script from "./TabelaResultadosProjetoGovernador.vue?vue&type=script&lang=js"
export * from "./TabelaResultadosProjetoGovernador.vue?vue&type=script&lang=js"
import style0 from "./TabelaResultadosProjetoGovernador.vue?vue&type=style&index=0&id=71dd70c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dd70c4",
  null
  
)

export default component.exports